import { render } from "./DomainAuthority.vue?vue&type=template&id=00c577e8"
import script from "./DomainAuthority.vue?vue&type=script&lang=js"
export * from "./DomainAuthority.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__